import type { OrderAppOrderReturnReason } from '@/graphql/orderApp/api';

export type OrderReturnReason = OrderAppOrderReturnReason;

export const returnReasons: { label: string; value: OrderReturnReason }[] = [
  {
    label: 'Purchased as Gift',
    value: 'PURCHASED_AS_GIFT',
  },
  {
    label: 'Did not like color',
    value: 'DID_NOT_LIKE_COLOR',
  },
  {
    label: 'Style not as expected',
    value: 'STYLE_NOT_AS_EXPECTED',
  },
  {
    label: 'Did not like size',
    value: 'DID_NOT_LIKE_SIZE',
  },
  {
    label: 'Better price elsewhere',
    value: 'BETTER_PRICE_ELSEWHERE',
  },
  {
    label: 'Purchased different brand',
    value: 'PURCHASED_DIFFERENT_BRAND',
  },
  {
    label: 'Did not pay',
    value: 'DID_NOT_PAY',
  },
  {
    label: 'Refuse package',
    value: 'REFUSE_PACKAGE',
  },
  {
    label: 'Lost package',
    value: 'LOST_PACKAGE',
  },
  {
    label: 'Others (new)',
    value: 'OTHERS',
  },
];

const submitLabelByReasonCode = new Map(
  returnReasons.map((r) => [r.value, r.label]),
);

export function getReturnReasonSubmitLabel(
  reasonCode: string,
): string | undefined {
  return submitLabelByReasonCode.get(reasonCode as OrderReturnReason);
}
